export default "__VITE_ASSET__4iXHbUJR__";